const config = {
    default: {
        API_URL: 'https://api-v2.designerdailyreport.com',
        PREVIEW_URL: 'http://localhost:3000',
        PANDALYTICS_URL: 'http://localhost:1000',
    },
    staging: {
        API_URL: 'https://api-v2.designerdailyreport.com',
        PREVIEW_URL: 'https://v2.designerdailyreport.com/',
        PANDALYTICS_URL: 'https://al-staging.designerdailyreport.com',
    },
    production: {
        API_URL: 'https://api.designerdailyreport.com',
        PREVIEW_URL: 'https://stage.designerdailyreport.com',
        PANDALYTICS_URL: 'https://al.designerdailyreport.com',
    },
};
const getConfig = (configKey) => {
    const env = process.env.ENVIRONMENT || process.env.NODE_ENV || 'development';
    const allConfig = Object.assign(Object.assign(Object.assign({}, config.default), (env === 'staging' ? config.staging : {})), (env === 'production' ? config.production : {}));
    return allConfig[configKey];
};
export default getConfig;
